var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPdf24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.5a.5.5 0 010-1h11A1.5 1.5 0 0019 19V8h-2.5a2 2 0 01-2-2V3.5h-6A1.5 1.5 0 007 5v2.499a.5.5 0 01-1 0V5a2.5 2.5 0 012.5-2.5h6.665a.5.5 0 01.36.153l4.335 4.499a.5.5 0 01.14.347V19a2.5 2.5 0 01-2.5 2.5h-11z",
    fill: "#0E1C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 9a2 2 0 00-2 2v5a2 2 0 002 2h12a2 2 0 002-2v-5a2 2 0 00-2-2h-12zm1.324 5.296c1.04 0 1.728-.56 1.728-1.6 0-1.048-.688-1.608-1.728-1.608h-2V16H3.84v-1.704h.984zm.72-1.6c0 .424-.256.728-.784.728h-.92V11.96h.92c.528 0 .784.296.784.736zm3.21 2.4v-3.112h.68c.936 0 1.448.6 1.448 1.56 0 .952-.512 1.552-1.448 1.552h-.68zM7.738 16h1.736c1.488 0 2.424-.96 2.424-2.456s-.936-2.456-2.424-2.456H7.738V16zm6.39-1.88V16h-1.015v-4.912h3.272v.896h-2.256v1.248h2.088v.888h-2.088z",
    fill: "#FD597B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf24);
export default __webpack_public_path__ + "static/media/icon-pdf-24.68f99ba1.svg";
export { ForwardRef as ReactComponent };